/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Category,
    CategoryFromJSON,
    CategoryToJSON,
} from './';

/**
 *
 * @export
 * @interface ZendeskKnowledge
 */
export interface ZendeskKnowledge {
    /**
     *
     * @type {Array<Category>}
     * @memberof ZendeskKnowledge
     */
    categories: Category[];
}

export function ZendeskKnowledgeFromJSON(json: any): ZendeskKnowledge {
    return ZendeskKnowledgeFromJSONTyped(json, false);
}

export function ZendeskKnowledgeFromJSONTyped(json: any, _: boolean): ZendeskKnowledge {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'categories': ((json['categories'] as any[]).map(CategoryFromJSON)),
    };
}

export function ZendeskKnowledgeToJSON(value?: ZendeskKnowledge | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'categories': ((value.categories as any[]).map(CategoryToJSON)),
    };
}
